import type { FC } from 'react';
import { Menu, ActionIcon } from '@mantine/core';

import { Image, RefreshCw, Trash2, Edit, EllipsisVertical } from 'lucide-react';

import type { TProject } from '@newo/api/gateway';

interface ProjectMenuProps {
    project: TProject;
    onEditProject: (project: TProject) => void;
    onDeleteProject: (project: TProject) => void;
    onMakeProjectImage: (project: TProject) => void;
    onForceUpdateProject: (project: TProject) => void;
}

const ProjectMenu: FC<ProjectMenuProps> = ({
    project,
    onEditProject,
    onDeleteProject,
    onMakeProjectImage,
    onForceUpdateProject
}) => {
    const handleEditProject = () => {
        onEditProject(project);
    };

    const handleDeleteProject = () => {
        onDeleteProject(project);
    };

    const handleMakeProjectImage = () => {
        onMakeProjectImage(project);
    };

    const handleForceUpdateProject = () => {
        onForceUpdateProject(project);
    };

    return (
        <Menu withinPortal position="bottom-end">
            <Menu.Target>
                <ActionIcon size="lg" variant="transparent">
                    <EllipsisVertical />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item leftSection={<Edit />} onClick={handleEditProject}>
                    Edit Project
                </Menu.Item>
                <Menu.Item
                    leftSection={<Image />}
                    onClick={handleMakeProjectImage}
                >
                    Make Project Image
                </Menu.Item>
                <Menu.Item
                    leftSection={<RefreshCw />}
                    onClick={handleForceUpdateProject}
                >
                    Force Update Project
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item
                    className="text-red-6"
                    leftSection={<Trash2 />}
                    onClick={handleDeleteProject}
                >
                    Delete Project
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default ProjectMenu;
